const d365formblockjs = {
    formId: null,
    disableRecaptcha: null,
    formName: null,
    formType: null,
    preventDefault: true,
    Init: function (formId, disableRecaptcha, formName, formType) {
        this.formId = formId;
        this.disableRecaptcha = disableRecaptcha;
        this.formName = formName;
        this.formType = formType;
        if (this.disableRecaptcha && this.disableRecaptcha === "false") {
            this.LoadGoogleReCaptcha();

            document.addEventListener("d365mkt-formsubmit", async function (event) {
                if (d365formblockjs.preventDefault) {
                    event.preventDefault();
                } else {
                    return;
                }

                if (recaptchavalidation) {
                    var isValid = await recaptchavalidation.IsValid();
                    if (isValid) {
                        d365formblockjs.SubmitD365Form();
                    }
                } else {
                    d365formblockjs.SubmitD365Form();
                }
            });
        }

        document.addEventListener("d365mkt-afterformsubmit", function (event) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'D365FormSubmit',
                'formName': d365formblockjs.formName,
                'formType': d365formblockjs.formType
            });
        });
    },
    LoadGoogleReCaptcha: async function () {
        var src = "/dist/js/RecaptchaValidationScripts.min.js";
        var script = document.createElement("script");
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.setAttribute("src", src);
        document.querySelector("body").appendChild(script);
    },
    SubmitD365Form: function () {
        this.preventDefault = false;
        const formDiv = document.querySelector('div[data-form-id="' + this.formId + '"]');
        if (!formDiv) {
            console.error('Div with Form not found');
            return;
        }

        const form = formDiv.querySelector('form.marketingForm');
        if (!form) {
            console.error('Form element not found');
            return;
        }

        var submitBtn = form.querySelector(".submitButton");
        if (submitBtn) {
            if (submitBtn.type === "submit") {
                setTimeout(() => {
                    submitBtn.click();
                }, 200);
            } else {
                console.error("The button is not a submit button.");
            }
        }
    }
};

window.d365formblockjs = d365formblockjs;